import {
  delById,
  getPageList
} from '@/api/oss'

export default {
  state: {
    list: [],
    loading: false,
    pageSize: 10,
    pageNum: 1,
    total: 0
  },
  mutations: {
    setOssList (state, userList) {
      state.list = userList
    },
    setOssLoading (state, loading) {
      state.loading = loading
    },
    setOssPageSize (state, pageSize) {
      state.pageSize = pageSize
    },
    setOssPageNum (state, pageNum) {
      state.pageNum = pageNum
    },
    setOssTotal (state, total) {
      state.total = total
    },
    setOssSelectData (state, data) {
      state.list = data.records
      state.loading = false
      state.total = data.total
      state.pageNum = data.pageNum
      state.pageSize = data.pageSize
    }
  },
  getters: {
    ossList: state => state.list,
    ossTotal: state => state.total,
    ossLoading: state => state.loading
  },
  actions: {
    getPageList ({ state, commit }, data) {
      commit('setOssLoading', true)
      return new Promise((resolve, reject) => {
        getPageList(data).then(res => {
          const data = res.data.result
          commit('setOssSelectData', data)
          resolve()
        }).catch(err => {
          commit('setOssLoading', false)
          reject(err)
        })
      })
    },
    delById ({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        delById(data).then(res => {
          const message = res.data.message
          resolve(message)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/oss.js